<template>
  <child-container
      :container-name="containerName"
      :container-title="containerTitle"
      :width="rootMenuWidth"
      ref="container"
      :container-div-style="containerDivStyle"
      @container-hidden="containerHidden"
  >
  <oxygen-button-ribbon ref="tabRibbon" :buttons="tabButtons"></oxygen-button-ribbon>
    <div v-show="!calendarMode" ref="tableContainer" style="overflow:auto;" :style="{'max-height': containerMaxHeight}">
      <oxygen-menu-table
          :row-style="rowStyle"
          ref="menuTable"
          class="root-menu"
          :tableData="tableData"
          @vue:mounted="menuTableMounted"
      ></oxygen-menu-table>
    </div>
    <div v-show="calendarMode">
      <oxygen-calendar-widget
          :showPeriod="true"
          :readonly="true"
          :events="calendarEvents"
          :eventText="calendarEventText"
          :threads="calendarThreads"
          :timelineViewName="timelineViewName"
          @eventAdded="calendarEventAdded"
          @eventClicked="calendarEventClicked"
          @dateClicked="calendarDateClicked"
          @dateChanged="calendarDateChanged"
          class="mx-auto border"
          style="width: 100%;"
          :style="{height: calendarHeight}"
          ref="calendar"
          :component="OxygenMapPin"
      ></oxygen-calendar-widget>
    </div>
  </child-container>
  <menu-modal ref="threadRoleModal" :table-data="threadRolesTableData" :modal-name="threadRoleModalName" :panel-title="threadRoleModalTitle" :menu-items="threadRoles" :styles="threadRoleModalStyles"/>
  <menu-modal ref="subjectRoleModal" :table-data="subjectRolesTableData" :modal-name="subjectRoleModalName" :panel-title="subjectRoleModalTitle" :menu-items="subjectRoles" :styles="subjectRoleModalStyles"/>
  <menu-modal ref="optionsModal" :menu-table-props="optionsModalMTProps" :modal-name="optionsModalName" :panel-title="optionsModalTitle" :menu-items="rootMenuOptions" :styles="optionsModalStyles"/>
  <p-e-details :detailsData="detailsData" ref="detailsContainer"></p-e-details>
  <options-menu
      :show-checkbox="false"
      :show-folder="false"
      ref="optionsMenu"
      :title="optionsMenuTitle"
      :container-name="optionsMenuContainerName"
      :options="optionsMenuOptions"
  ></options-menu>
  <form-container
      :title="formContainerTitle"
      :form-rows="formRows"
      ref="formContainer"
  ></form-container>
</template>

<script setup>
import { reactive, onMounted, watch, ref, getCurrentInstance, nextTick } from 'vue';
import ChildContainer from './../ChildContainer/ChildContainer.vue';
import OxygenMenuTable from './../OxygenMenuTable/OxygenMenuTable.vue';
import { deviceStore } from './../../../stores/deviceStore';
import TitleComponent from './../TitleComponent/TitleComponent.vue';
import OxygenRibbon from './../OxygenRibbon/OxygenRibbon.vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import MenuModal from './../MenuModal/MenuModal.vue';
import PEDetails from './../PEDetails/PEDetails.vue';
import OxygenButtonRibbon from './../OxygenButtonRibbon/OxygenButtonRibbon.vue';
import OptionsMenu from './../OptionsMenu/OptionsMenu.vue';
import FormContainer from './../FormContainer/FormContainer.vue';
import OxygenMapPin from "../OxygenMapWidget/oxygenmappin.vue";
import OxygenCalendarWidget from "../OxygenCalendarWidget/CalendarWidget.vue";
import {searchHistory} from "./../OxygenUtil/oxygenutil.js";

const store = deviceStore();
const viewports = reactive(store.viewPorts), menuTable = ref(null), showRootMenu = ref(false), headerRibbon = ref(null),
    containerTitle = ref('Home Menu'), containerName = ref('rootMenu'), container = ref(null);
let detailsData = ref({});
const rootMenuData = reactive(store.rootMenu), meetingsData = reactive(store.meetingMenu);

//window._deviceStore = store;
let rootMenuWidth = ref( window.innerWidth >= 769 ? '769px' : `${window.innerWidth}px`);

const optionsMenuTitle = ref('Options'), optionsMenuContainerName = ref(`opt${oxygenUtil.getUUID()}`), optionsMenuOptions = reactive([]), optionsMenu = ref(null);

let rowStyle = ref({ 'line-height': '40px' });

const tableData = reactive({
  showHeader: false,
  showCheckbox: true,
  showFolder: true,
  showRightMenu: true,
  cols: [
    {
      callback: () => {
      },
      header: 'Index',
      type: 'html'
    },
    {
      callback: () => {
      },
      header: 'Details',
      type: 'icon'
    },
    {
      callback: () => {
      },
      header: 'Name',
      type: 'html'
    },
    {
      callback: () => {
      },
      header: 'Open',
      type: 'icon'
    }
  ]
});

//border:2px solid ${borderColor};border-radius:0.3em;padding:4px;box-shadow:0 0 0 2px white,0 0 0 4px ${borderColor}
let containerDivStyle = ref({ 'border': '2px solid #0072c5', 'border-radius': '0.3em', 'padding': '4px', 'box-shadow': '0 0 0 2px white, 0 0 0 4px #0072c5'  });

onMounted(()=>{
  //addSampleRootMenuItems();
  //putViewportsInTable();
  window._rootMenu = getCurrentInstance();
  addEventListeners() ;
  getAttributionBookmarks();
});

let bookmarks = ref([]);
async function getAttributionBookmarks() {
  let client = getMainClient();
  if(client && client.Attribution) {
    bookmarks.value = await oxygenUtil.getAttributionBookmarks(client.Attribution);
  }
}

function addEventListeners() {
  window.addEventListener(`${oxygenUtil.getSessionId()}-recent-update`, (ev)=>{
    putRecentData();
  });
}

function menuTableMounted() {
  if(meetingMode.value) {
    window._rootMenuTable = menuTable.value;
    window._rootMenuData = rootMenuData;
    putMeetingData();
  }
}

watch(
    rootMenuData,
    (newVal)=> {
      /*
      if (menuTable.value.tableData && menuTable.value.tableData.dataRows && menuTable.value.tableData.length) {
        menuTable.value.resetTable();
      }

       */
      //console.log('watch-rootMenuData', 'newVal:', newVal);
      if(!recentMode.value) {
        //putRootMenuData();
      }
      if(meetingMode && menuTable.value) {
        menuTable.value.resetTable();
        putMeetingData();
      }
    },
    {
      deep: true
    }
);


watch(
    meetingsData,
    (newVal)=> {


      if(meetingMode && menuTable.value) {
        menuTable.value.resetTable();
        putMeetingData();
      }
    },
    {
      deep: true
    }
);


function putRootMenuData() {
  menuTable.value.resetTable();
  putViewportsInTable();
  containerMaxHeight.value = calcContainerMaxHeight();
}

async function putRecentData() {
  menuTable.value.resetTable();
  await addRecentDataInTable();
  containerMaxHeight.value = calcContainerMaxHeight();
}

addEventListener("resize", (event) => {
  containerMaxHeight.value = calcContainerMaxHeight();
});

const detailsContainer = ref(null), tableContainer = ref(null);
function showDetails(dataRow, index, ev) {
  console.log('showDetail', 'dataRow:', dataRow, 'ev:', ev);
  detailsData.value = dataRow.data;
  detailsContainer.value.showContainerAlignedToElementInViewport(ev.target, 'bottom', tableContainer.value.getBoundingClientRect());
}

let recentSessionSize = ref(5), sessionSize = ref(10);
async function getRecentData() {
  let recentData = await oxygenUtil.runDBQuery(
      `select * from OxygenDatabase.Recent r where r.SessionID
in (select * from (select SessionID from OxygenDatabase.Recent where  AttributionID = ? group by SessionID order by  MAX(CreationTime) desc limit ${recentSessionSize.value} ) as r2 )
order by r.CreationTime desc;`,
      [window.LivingScript_0070.context.attribution.find(e => e.AccountType === 'PrimaryAccount').ID]
  );

  let sessionIds = new Set();
  recentData.forEach((e)=>{
    sessionIds.add(e.SessionID);
  });
  let { components } = await oxygenUtil.callCommonServiceAPI(
      "simplia-api",
      'getMultipleComponents',
      {
        componentIds: Array.from(sessionIds)
      }
  );

  let sessions = Object.values(components);
  sessions.sort((a,b)=>{
    return b.Node && b.Node.localeCompare(a.Node);
  });

  return { recentRows: recentData, sessions};
}

async function addRecentDataInTable() {
  let {recentRows, sessions} = await getRecentData();
  sessions.forEach((s,i)=>{

    menuTable.value.addRow(
        {
          cols: [
            {
              html: `<span style="font-size:${oxygenUtil.config.fontSize};">[${i}/${i}]</span>`,
              styleObj: { 'width': '3em'},
              callback: (dataRow) => {

              }
            },
            {
              html: ``,
              styleObj: { 'padding-left': '13px'},
              callback: (...args) => {
                //showDetails(...args);
              }
            },
            {
              html: `<span style="font-size:${oxygenUtil.config.fontSize};">${(s.CurrentContext && s.CurrentContext.SessionName) || s.CreationTime}</span>`,
              callback: () => {

              }
            },
            {
              html: ``,
              callback:()=>{}
            }
          ],
          data: s,
          path: `${i}`.padStart(5,'0'),
          showFolder: true,
          show: true,
          rightMenuCallback: (...args) => {
            showSessionOptionsModal(...args);
          }
        }
    );
    recentRows.filter(e => e.SessionID === s.Node).slice(0, sessionSize.value).forEach((e,j)=>{

      menuTable.value.addRow(
          {
            cols: [
              {
                html: `<span style="font-size:${oxygenUtil.config.fontSize};">[${i}/${j+1}]</span>`,
                styleObj: { 'width': '2.3em'},
                callback: (dataRow) => {

                }
              },
              {
                html: `<span class="fas fa-question" style="color: lightgrey; font-size:13px;"></span>`,
                styleObj: { 'padding-left': '13px'},
                callback: (...args) => {
                  //showDetails(...args);
                }
              },
              {
                html: `<span style="font-size:${oxygenUtil.config.fontSize};">${e.LeftDN} / ${e.RightDN}</span>`,
                callback: (dataRow) => {
                  openRecentPE(dataRow);
                }
              },
              {
                html: ``,
                callback:()=>{}
              }
            ],
            data: e,
            path: `${i}`.padStart(5,'0') + '/' + `${j}`.padStart(5,'0'),
            showFolder: false,
            show: false,
            rightMenuCallback: (...args) => {
              console.log('rightMenuCallback', 'args:', args);
              showOptionsModal(...args);
            }
          }
      );
    })
  })
}

function openRecentPE(dataRow) {
  //console.log('Recent-callback', 'contextPE:', window.LivingScript_0070.context.contextPE);
  let mainClient = window.devStore.clients.find((e)=>{
    //console.log('Recent-callback', 'matching grantPE:', JSON.parse(e.ClientContext).GrantPE);
    return JSON.parse(e.ClientContext).GrantPE === window.LivingScript_0070.context.contextPE;
  });
  //console.log('Recent-callback', 'mainClient:', mainClient);
  hideMenu();
  window.oxygenUtil.pullPE(
      {
        ByClientID : mainClient.Client,
        InitialContext : {
          ByClientID : mainClient.Client
        },
        OpenPE : dataRow.data.RecentPE
      }
  );
}

let meetingMode = ref(true), contextsMode = ref(false), alertsMode = ref(false), calendarMode = ref(false), offersMode = ref(false), requestsMode = ref(false);
function putViewportsInTable() {
  rootMenuData.forEach((rootMenuItem)=> {
    //let client = window.botStore.clients.find(e => (e.Client === viewport.ClientID));
    //console.log('rootMenuItem:', rootMenuItem);
    menuTable.value.addRow(
        {
          cols: [
            {
              html: `<span style="font-size:${oxygenUtil.config.fontSize};">[${rootMenuItem.ParentIndex || '0'}/${rootMenuItem.LocalIndex || '0'}]</span>`,
              styleObj: { 'width': '2.3em'},
              callback: (dataRow) => {

              }
            },
            {
              html: `<span class="fas fa-question" style="color: lightgrey; font-size:13px;"></span>`,
              styleObj: { 'padding-left': '13px'},
              callback: (...args) => {
                showDetails(...args);
              }
            },
            {
              type: 'component',
              componentName: TitleComponent,
              props: {
                titleData: rootMenuItem,
                threadRoleModal,
                subjectRoleModal,
                threadRoleModalStyles,
                subjectRoleModalStyles,
                subjectRoles,
                threadRoles,
                simpleMode: true,
                meetingMode,
                callback: panelTitleClicked
              }
            },
            {
              html: `<span style="padding-left:5px;" class="${(rootMenuItem.ClientRowID && rootMenuItem.ViewPortID) ? 'fal fa-globe green-color' : ''}"/>`,
              callback:()=>{}
            }
          ],
          data: rootMenuItem,
          path: rootMenuItem.Path,
          showFolder: false,
          show: rootMenuItem.Path.includes("/") ? false : true,
          rightMenuCallback: (...args) => {
            console.log('rightMenuCallback', 'args:', args);
            showOptionsModal(...args);
          }
        }
    );
  });
}

function panelTitleClicked(rootMenuItem) {
  console.log('panelTitleClicked', 'rootMenuItem:', rootMenuItem);
  //window.BotServices.openClient(rootMenuItem);
  window.BotServices.PullRootMenu(rootMenuItem);
  //window.BotServices.ActiveViewport(rootMenuItem.ViewportID);
  window.oxygenUtil.putViewportOnTop(rootMenuItem.ViewportID);
  hideMenu();
}

//Thread Role Modal
let threadRoleModal = ref(null),
    threadRoleModalName = ref('threadRoleModal'),
    threadRoleModalTitle = ref('Role'),
    threadRoles = reactive([]),
    threadRolesTableData = reactive({
      showCheckbox: true,
      checkboxCol: {
        settings: {
          disabled: true
        }
      }
    }),
    threadRoleModalStyles = reactive({});

//Subject Role Modal
let subjectRoleModal = ref(null),
    subjectRoleModalName = ref('subjectRoleModal'),
    subjectRoleModalTitle = ref('Role'),
    subjectRoles = reactive([]),
    subjectRolesTableData = reactive({
      showCheckbox: true
    }),
    subjectRoleModalStyles = reactive({});


//Options Modal
let optionsModal = ref(null),
    optionsModalName = ref('optionsModal'),
    optionsModalTitle = ref('Options'),
    rootMenuOptions = reactive([]),
    optionsModalMTProps = reactive({
      hideFolderCol: true,
      hideCheckboxCol: true
    }),
    optionsModalStyles = reactive({ width: '150px'});

function showOptionsModal(dataRow, index, event, target) {
  console.log('showOptionsModal', 'event:', event, ' - optionsModal:', optionsModal);
  addOptions(dataRow.data);
  /*
  let rmIcon = event.target.getBoundingClientRect();
  optionsModalStyles['position'] = 'absolute';
  optionsModalStyles['top'] = `${rmIcon.top + rmIcon.height}px`;
  optionsModalStyles['left'] = `${rmIcon.left}px`;
  optionsModal.value.showModal();
   */
  optionsMenu.value.showMenuAlignedToElement(target, 'right', 'bottom');
}

function showSessionOptionsModal(dataRow, index, event, target) {
  addSessionOptions(dataRow);
  optionsMenu.value.showMenuAlignedToElement(target, 'right', 'bottom');
}

let standardOptions = reactive([
  { icon: '', title: 'Open', callback:(rowData)=>{
      window.BotServices.PullRootMenu(rowData.item);
      hideMenu();
    }, path: '00001' },
  { icon: '',  title: 'Create URL', callback:(rootMenuItem)=>{
      hideMenu();
    }, path: '00002' },
  { icon: '',  title: 'Hide', callback:(rowData)=>{
      window.devStore.HidePanel(rowData.item.ViewPortID);
    }, path: '00003' },
  { icon: '',  title: 'Close', callback: (rowData)=>{
      window.devStore.ClosePanel(rowData.item.ViewPortID);
    }, path: '00004' }
]);

let mainAttributionRecord = ref(null);
async function removeAsHomepageBookmark() {
  let client = getMainClient();
  if(client && client.Attribution) {
    if(!mainAttributionRecord.value) {
      mainAttributionRecord.value = await oxygenUtil.getAttributionRecord(client.Attribution)
    }
    await oxygenUtil.runDBQuery(
        `delete from OxygenDatabase.AttributionBookmarks where AttributionID = ? and Type = ?`,
        [ mainAttributionRecord.value.AttributionID, 'Homepage']
    );
  }
}

function setAsHomepageBookmark(rowMenuItem) {
  let type = {
    'Child': ()=> { setChildAsHomepageBookmark(rowMenuItem) },
    'Parent': ()=> { setParentAsHomepageBookmark(rowMenuItem) }
  };

  console.log('setAsHomepageBookmark', 'rowMenuItem:', rowMenuItem);
  if(rowMenuItem.Type && type[rowMenuItem.Type]) {
    type[rowMenuItem.Type]();
  }
}

function setChildAsHomepageBookmark(...args) {
  saveHomepageBookmark(...args);
}

function setParentAsHomepageBookmark(...args) {
  saveHomepageBookmark(...args);
}

function getMainClient() {
  let mainClientItem = window.devStore.rootMenu.find(e => (e.LocalIndex === 1 && e.ParentIndex === 1))
  return window.devStore.clients.find(e => e.Client === mainClientItem.ClientRowID);
}

async function saveHomepageBookmark(rootMenuItem) {
  let client = getMainClient();
  if(client && client.Attribution) {
    let attributionRecord = await oxygenUtil.getAttributionRecord(client.Attribution);
    console.log('saveHomepageBookmark', 'rootMenuItem:', rootMenuItem, ' - rec:', attributionRecord);
    if(attributionRecord && attributionRecord.AttributionID) {
      console.log('saveHomepageBookmark', 'id:', attributionRecord.AttributionID);
      let json = JSON.stringify(rootMenuItem);
      let contextPE = oxygenUtil.createSimpleOES([rootMenuItem.LeftRole, rootMenuItem.LeftID, rootMenuItem.RightRole, rootMenuItem.RightID]);
      await oxygenUtil.runDBQuery(
          `insert into OxygenDatabase.AttributionBookmarks (AttributionID, Type, ArgJSON, ContextPE) values(?,?,?,?)
ON DUPLICATE KEY UPDATE ArgJSON = ?, ContextPE = ?`,
          [ attributionRecord.AttributionID, 'Homepage', json, contextPE, json, contextPE]
      );
    }
  }
}

async function addOptions(rootMenuItem) {
  optionsMenuOptions.length = 0;
  standardOptions.forEach(e => (e.item = rootMenuItem));
  optionsMenuOptions.push(...standardOptions, await addHomepageBookmarkOptions(rootMenuItem));
}

async function addHomepageBookmarkOptions(rootMenuItem) {
  let setOpt =   { icon: '', item: rootMenuItem, title: 'Set As Homepage Bookmark', callback:(rowData)=>{
          console.log('addHomepageBookmarkOptions-callback', 'rowData:', rowData);
          setAsHomepageBookmark(rowData.item);
          hideMenu();
        }, path: '00001-001' },
      unsetOpt = { icon: '', item: rootMenuItem, title: 'Remove As Homepage Bookmark', callback:(rowData)=>{
          removeAsHomepageBookmark(rowData.item);
          hideMenu();
        }, path: '00001-001' };

  //if(!bookmarks.value || !bookmarks.value.length) {
    await getAttributionBookmarks();
  //}

  let homepage;
  if(bookmarks.value && bookmarks.value.length && (homepage = bookmarks.value.find(e => e.Type === 'Homepage'))) {
    let json = oxygenUtil.tryParseJSON(homepage.ArgJSON);
    if(json.Type === 'Parent' &&
        (oxygenUtil.createSimpleOES([rootMenuItem.LeftRole, rootMenuItem.LeftID, rootMenuItem.RightRole, rootMenuItem.RightID]) ===
            (oxygenUtil.createSimpleOES([json.LeftRole, json.LeftID, json.RightRole, json.RightID])))) {
      return unsetOpt;
    }
    else if(json.Type === 'Child' && (oxygenUtil.createSimpleOES([rootMenuItem.LeftRole, rootMenuItem.LeftID, rootMenuItem.RightRole, rootMenuItem.RightID]) ===
        (oxygenUtil.createSimpleOES([json.LeftRole, json.LeftID, json.RightRole, json.RightID]))) && (JSON.stringify(json.Termination) === JSON.stringify(rootMenuItem.Termination))) {
      return unsetOpt;
    }
  }

  return setOpt;

}

function addSessionOptions(dataRow) {
  optionsMenuOptions.length = 0;



  let options = [  {
    icon: '',
    title: 'Restore Session',
    callback: ()=>{
      menuTable.value.getPathRows(`${dataRow.path}/`).forEach((e)=>{
        openRecentPE(e);
      });
      hideMenu();
    },
    path: `00001`
  },
    {
      icon: '',
      title: 'Rename Session',
      callback: ()=>{
        showRenameSessionForm(dataRow)
      },
      path: `00002`
    }];

  optionsMenuOptions.push(...options);
}



let lastActiveClient = {}, lastActiveViewportId = '';
function showMenu() {
  //$vfm.show('rootMenu');
  container.value.show();
  lastActiveClient = window.devStore.activeClient;
  window.devStore.setActiveClient({});
  lastActiveViewportId = window.devStore.activeViewportId;
  window.devStore.setActiveViewportId('');
}

function hideMenu() {
  container.value.hide();

}

function containerHidden() {
  window.devStore.setActiveClient(lastActiveClient);
  window.devStore.setActiveViewportId(lastActiveViewportId);
}

let containerMaxHeight = ref('');

function calcContainerMaxHeight() {
  if(tableContainer.value) {
    let rect = tableContainer.value.getBoundingClientRect();
    return `${window.innerHeight - rect.y - 1}px`;
  }
  return `${window.innerHeight}px`;
}


let tabRibbon = ref();
let recentMode = ref(false);
/*
let tabButtons = reactive([
  { id: 'links', html: 'Links', callback: ()=>{
      setTabButtonColor('links', '#0072C5');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('recent', 'grey');
      meetingMode.value = false;
      recentMode.value = false;
    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': '#0072C5'}},
  { id: 'meetings', html: 'Meetings', callback: ()=>{
      setTabButtonColor('links', 'grey');
      setTabButtonColor('meetings', '#0072C5');
      setTabButtonColor('recent', 'grey');
      meetingMode.value = true;
      recentMode.value = false;
    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}},
  {
    id: 'recent', html: 'Recent', callback: ()=>{
      setTabButtonColor('links', 'grey');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('recent', '#0072C5');
      meetingMode.value = false;
      recentMode.value = true;
    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}
  }
]);
*/

let tabButtons = reactive([
  {
    id: 'calendar', html: 'Calendar', callback: ()=>{
      setTabButtonColor('contexts', 'grey');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('alerts', 'grey');
      setTabButtonColor('calendar', '#0072C5');
      //setTabButtonColor('offers', 'grey');
      //setTabButtonColor('requests', 'grey');
      calendarMode.value = true;
      offersMode.value = requestsMode.value = alertsMode.value = contextsMode.value = meetingMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}
  },
  { id: 'meetings', html: 'Meetings', callback: ()=>{
      setTabButtonColor('contexts', 'grey');
      setTabButtonColor('meetings', '#0072C5');
      setTabButtonColor('alerts', 'grey');
      setTabButtonColor('calendar', 'grey');
      //setTabButtonColor('offers', 'grey');
      //setTabButtonColor('requests', 'grey');
      meetingMode.value = true;
      calendarMode.value = offersMode.value = requestsMode.value = contextsMode.value = alertsMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': '#0072C5'}},
  { id: 'contexts', html: 'Contexts', callback: ()=>{
      setTabButtonColor('contexts', '#0072C5');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('alerts', 'grey');
      setTabButtonColor('calendar', 'grey');
      //setTabButtonColor('offers', 'grey');
      //setTabButtonColor('requests', 'grey');
      contextsMode.value = true;
      calendarMode.value = offersMode.value = requestsMode.value = meetingMode.value = alertsMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}},
  {
    id: 'alerts', html: 'Alerts', callback: ()=>{
      setTabButtonColor('contexts', 'grey');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('alerts', '#0072C5');
      setTabButtonColor('calendar', 'grey');
      //setTabButtonColor('offers', 'grey');
      //setTabButtonColor('requests', 'grey');
      alertsMode.value = true;
      calendarMode.value = offersMode.value = requestsMode.value = contextsMode.value = meetingMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}
  }/*,
  {
    id: 'offers', html: 'Offers', callback: ()=>{
      setTabButtonColor('contexts', 'grey');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('alerts', 'grey');
      setTabButtonColor('calendar', 'grey');
      setTabButtonColor('offers', '#0072C5');
      setTabButtonColor('requests', 'grey');
      offersMode.value = true;
      calendarMode.value = requestsMode.value = alertsMode.value = contextsMode.value = meetingMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}
  },
  {
    id: 'requests', html: 'Requests', callback: ()=>{
      setTabButtonColor('contexts', 'grey');
      setTabButtonColor('meetings', 'grey');
      setTabButtonColor('alerts', 'grey');
      setTabButtonColor('calendar', 'grey');
      setTabButtonColor('offers', 'grey');
      setTabButtonColor('requests', '#0072C5');
      requestsMode.value = true;
      calendarMode.value = offersMode.value = alertsMode.value = contextsMode.value = meetingMode.value = false;

    }, disabled: false, show: true, orientation: 'left', style: { 'background-color': 'white', 'color': 'grey'}
  }*/
]);
/*
watch(
    recentMode,
    (newVal)=>{
      console.log('watch-recentMode:', newVal);
      if(newVal) {
        putRecentData();
      }
      else {
        putRootMenuData();
      }
    }
);

 */

watch(
    meetingMode,
    (newVal)=>{
      if(newVal && menuTable.value) {
        menuTable.value.resetTable();
        putMeetingData();
      }
    },
    {
      immediate: true
    }
);

watch(
    contextsMode,
    (newVal)=>{
      if(newVal && menuTable.value) {
        menuTable.value.resetTable();
        putContextsData();
      }

    }
);

watch(
    alertsMode,
    (newVal)=>{
      if(newVal && menuTable.value) {
        menuTable.value.resetTable();
        putAlertsData();
      }
    }
);

watch(
    offersMode,
    (newVal)=>{
      if(newVal && menuTable.value) {
        menuTable.value.resetTable();
        putOffersData();
      }
    }
);

watch(
    requestsMode,
    (newVal)=>{
      if(newVal && menuTable.value) {
        menuTable.value.resetTable();
        putRequestsData();
      }
    }
);

watch(
    calendarMode,
    async (newVal)=>{
      if(newVal&& menuTable.value) {
        await putCalendarData();
      }
    }
);


let rootFolders = ['Live', 'Future', 'Past', 'Folders'];

async function putMeetingData() {
  putRootFolders()
  putDataInFolder(meetingsData.Live, 0);
  putDataInFolder(meetingsData.Recent, 2);
}

function putDataInFolder(dataItems, folderIndex, folderCallback, colComponent) {
  dataItems.forEach((dataItem, index)=> {
    console.log('putLiveMeetings', 'dataItem:', dataItem);
    menuTable.value.addRow(
        Object.assign({
          cols: [
            {
              html: `<span style="font-size:${oxygenUtil.config.fontSize};">[${dataItem.ParentIndex || '0'}/${dataItem.LocalIndex || '0'}]</span>`,
              styleObj: { 'width': '2.3em'},
              callback: (dataRow) => {

              }
            },
            {
              html: `<span class="fas fa-question" style="color: lightgrey; font-size:13px;"></span>`,
              styleObj: { 'padding-left': '13px'},
              callback: (...args) => {
                showDetails(...args);
              }
            },
            colComponent || {
              type: 'component',
              componentName: TitleComponent,
              props: {
                titleData: dataItem,
                threadRoleModal,
                subjectRoleModal,
                threadRoleModalStyles,
                subjectRoleModalStyles,
                subjectRoles,
                threadRoles,
                simpleMode: true,
                meetingMode,
                callback: panelTitleClicked
              }
            },
            {
              html: `<span style="padding-left:5px;" class="${(dataItem.ClientRowID && dataItem.ViewPortID) ? 'fal fa-globe green-color' : ''}"/>`,
              callback:()=>{}
            }
          ],
          data: dataItem,
          path: `${folderIndex}/${index}`,
          showFolder: false,
          show: dataItem.Path.includes("/") ? false : true,
          rightMenuCallback: (...args) => {
            console.log('rightMenuCallback', 'args:', args);
            showOptionsModal(...args);
          }
        }, folderCallback ? { folderCol: {
            callback: folderCallback
          } } : {} )
    );
  });
}

async function putContextsData() {
  putRootFolders();
  putDataInFolder(rootMenuData, 0);
}

async function putAlertsData() {
 putRootFolders([
   async ()=>{
     let results = await oxygenUtil.searchHistory(window.botStore.clients[0].Client, window.LivingScript_0070.context.grantId, {
       where: [
         { name: 'RootAttributionOID', value: mainAttributionRecord.value.AttributionOID },
       ],
       scripts: [

       ]
     })
   },
   ()=>{

   },
   ()=>{

   },
   ()=>{

   }
 ]);

}

async function putOffersData() {
  putRootFolders();
}

async function putRequestsData() {
  putRootFolders();
}

function putRootFolders(folderColCallbacks) {
  rootFolders.forEach((folder, index)=>{
    menuTable.value.addRow(
        Object.assign({
          cols: [
            {
              html: `<span class="far fa-folder" style="font-size:${oxygenUtil.config.fontSize};"></span>`,
              styleObj: { 'width': '2.3em'},
              callback: (dataRow) => {

              }
            },
            {
              html: `<span class="fas fa-question" style="color: lightgrey; font-size:13px;"></span>`,
              styleObj: { 'padding-left': '13px'},
              callback: (...args) => {
                showDetails(...args);
              }
            },
            {
              html: `<span style="font-size:${oxygenUtil.config.fontSize};">${folder}</span>`
            },
            {
              html: ``,
              callback:()=>{}
            }
          ],
          data: {name: folder},
          path: `${index}`,
          showFolder: true,
          show: true,
          rightMenuCallback: (...args) => {

          }
        }, (Array.isArray(folderColCallbacks) && folderColCallbacks.length) ? { folderCol: { callback: folderColCallbacks[index] } } : {} )
    );
  });
}

function setTabButtonColor(id, color) {
  tabButtons.find(e => e.id === id).style['color'] = color;
}

/**
 * Form Related Code
 */

let formContainerTitle = ref(''), formRows = reactive([]), formContainer = ref(null);

async function showRenameSessionForm(dataRow) {

  formContainerTitle.value = "Rename Session";
  formRows.length = 0;

  formRows.push(
      {
        type: "input",
        name: "name",
        label: "Session Name",
        value: dataRow.data.CurrentContext.SessionName || ''
      },
      {
        type: "button",
        css: "spaced-button",
        name: "save",
        text: "Save",
        size: "medium",
        view: "flat",
        color: "primary"
      }
  );
  formContainer.value.showContainerAlignedToElementInViewport(
      tabRibbon.value.$el,
      'bottom'
  );

  await nextTick();
  formContainer.value.formInstance.getItem("save").events.on("click", async ()=>{
    let sessionName = formContainer.value.formInstance.getItem("name").getValue();
    await oxygenUtil.callCommonServiceAPI(
        "simplia-api",
        "updateComponentEx",
        {
          componentId: dataRow.data.Node,
          values: {
            'set': {
              'CurrentContext.SessionName': sessionName
            }
          }
        }
    );
    await putRecentData();
    formContainer.value.hide();
  });
}

/**
 * Calendar-related Data
 */

let calendarEvents = ref([]), calendarEventText = ref(''), calendarThreads = reactive([]),  timelineViewName = ref(`timeline${oxygenUtil.getUUID()}`), calendarHeight = ref('500px');

async function putCalendarData() {
  calendarEvents.value = [];

  let grants = await getGrantEvents();

  let events = [];
  grants.forEach((e)=>{
    let event = {
      start_date: e.T1,
      end_date: e.T2,
      text: oxygenUtil.formatDN(e.GrantRightDN),
      user_data: {
        data: e
      }
    };
    events.push(event);
  });

  calendarEvents.value = events;
}

async function getGrantEvents() {
  return oxygenUtil.runDBQuery(
      `select * from OxygenDatabase.Grants where GrantLeftID = ? and ( ( T1 is not null) and (T2 is not null) ) `,
      [window.top.LivingScript_0070.context.credentialId]
  );
}

function calendarEventAdded(data) {

}

function calendarEventClicked(data) {
  //this.parent.debugLog('calendarEventClicked', 'data:', data);
  let dataRow = menuTable.value.getRow(data.id);
  let index = menuTable.value.getRowIndex(data.id);
  ////this.parent.debugLog('calendarEventClicked', 'dataRow:', dataRow);
  if(dataRow) {
    //this.showExistingEventOptions(data.id, $(this.$refs.calendar.$el).find(`div[event_id='${data.id}']`)[0]);
    //this.setupCalendarPopup(dataRow, index);
    /*
    this.$refs.calendar.showPop({
        title: dataRow.cols[this.textColIndexVal][this.textColDataAttrVal],
        //title: data.text,
        displayComponent: dataRow.secondRowComponent,
        displayComponentProps: dataRow.secondRowProps,
        showDisplayComponent: dataRow.showSecondRow
    });
     */
  }
}

function calendarDateClicked(data) {

}

function calendarDateChanged(data) {

}


defineExpose({
  showMenu,
  hideMenu,
  detailsContainer
});

</script>

<style>
.green-color {
  color: green;
}

</style>